import React from "react";
import Button from '@/_component/Common/button/Button';
import { AGENT_MIS_REPORT } from "@/_constant";


const PlanStatus = ({ selectedData, userDetails, togglePlanExpiryPopup, handleChangeAgentMisReport, language }) => {    
    return (
        <div className="d-flex flex-wrap gap-3 align-items-center">
            {selectedData.plan_days_remaining <= 0 ? (
                <>
                    {selectedData?.category_id === "-1" || selectedData?.category_id === -1 ? (
                        <span className="bg-white kg-warning shadow border-1 px-3 py-2 rounded-4 shadow-sm p-3">
                            <p className="rating-sec ms-0" id="mycode">
                                <b>Unique ID: {userDetails?.referralCode}</b>
                            </p>
                        </span>
                    ) : (
                        language(selectedData?.access_display_code) !== "Coordinator" && (
                            <span
                                onClick={togglePlanExpiryPopup}
                                className="bg-white kg-danger shadow border-1 px-3 py-2 rounded-4 shadow-sm p-3"
                            >
                                <b>{language("label.plan_expired")}</b>
                            </span>
                        )
                    )}
                </>
            ) : (
                selectedData.category_name !== "Assignee" && (
                    <span className="bg-white shadow border-1 px-3 py-3 rounded-4 shadow-sm p-3">
                        <b>{selectedData.plan_group}:</b> Expires in {selectedData.plan_days_remaining} days
                    </span>
                )
            )}
            {(selectedData?.category_id === "168" || selectedData?.category_id === "169" || selectedData?.category_id === "206" || selectedData?.category_id === "-1" || selectedData?.category_id === "-2") ?
                <span>
                    <Button
                        variant="outline"
                        primary outline rounded className="border-2"

                        onClick={(e) =>
                            selectedData.plan_days_remaining <= 0
                                ? togglePlanExpiryPopup()
                                : handleChangeAgentMisReport(selectedData?.category_id === "-2" ? AGENT_MIS_REPORT :"/FarmerMisReport")
                        }
                    >
                        <i className="bi bi-file-bar-graph me-2"></i>
                        {language("label.mis_report")}
                    </Button>
                </span>
                :
                <></>
            }
        </div>
    );
};

export default PlanStatus;  